module.exports = __webpack_public_path__ + "img/dark-green-circle-table-3.747d6395.png";